export default "__VITE_ASSET__BnB6R$QU__"